import React, { useState } from 'react';

import Translation from '@swf/components/Translation/Translation';
import Info from '@swf/core/assets/icons/info.svg';

import type { Announcement } from '../../types';

import { TXTWCL_Read_less, TXTWCL_Read_more } from './AnnouncementList.messages.json';
import styles from './AnnouncementList.scss';

interface Props {
  announcements?: Announcement[];
}

const AnnouncementList: React.FC<Props> = ({ announcements = [] }) => {
  const [announcementsItems, setAnnouncementsItems] = useState<Announcement[]>(announcements);
  const [expandedItems, setExpandedItems] = useState<boolean[]>(announcements.map(() => false));

  const handleExpand = (index: number) => {
    setExpandedItems((items) => [
      ...items.slice(0, index),
      !items[index],
      ...items.slice(index + 1)
    ]);
  };

  const handleClose = (index: number) => {
    setAnnouncementsItems((items) => {
      items.splice(index, 1);
      return [...items];
    });
  };

  return (
    <div className={styles.container}>
      {!!announcementsItems.length && (
        <div className={styles.inner}>
          {announcementsItems.map(({ title, description }, index) => (
            <div key={index} className={styles.announcement}>
              <div className={styles.preview}>
                <Info width={20} height={20} />
                <span className={styles.title}>{title}</span>
                <button onClick={() => handleExpand(index)} className={styles.readMore}>
                  {expandedItems[index] ? (
                    <Translation {...TXTWCL_Read_less} />
                  ) : (
                    <Translation {...TXTWCL_Read_more} />
                  )}
                </button>
                <button
                  className={styles.close}
                  onClick={() => handleClose(index)}
                  data-testid="announcement-close-button"
                />
              </div>
              {expandedItems[index] && (
                <div
                  className={styles.content}
                  dangerouslySetInnerHTML={{ __html: description }}
                ></div>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
export default AnnouncementList;
